import React, { useContext } from "react";
import ctl from "@netlify/classnames-template-literals";

import { Container, ReadMore, Button, Ntext } from "components";
import { heroSection } from "config/drivers";
import { AppContext } from "states/context";

import FromLastWeek from "svgs/drivers/hero-from-last-week.svg";
import RightBlur from "svgs/drivers/hero-right-blur.svg";
import LeftBlur from "svgs/drivers/hero-left-blur.svg";

import Driver from "jpegs/drivers/hero-driver.jpg";

const { title, description } = heroSection;

const DriversPageHero = () => {
  const { onOpen } = useContext(AppContext);

  return (
    <section className={wrapperStyle}>
      <Container className={heroStyle}>
        <section className="flex flex-col items-center lg:items-start max-w-[740px] z-10">
          <Ntext
            value={title}
            color="primary-100"
            className="!font-medium !text-[40px] md:!text-[72px] !leading-[48px] md:!leading-[80px] !-tracking-[2px] text-center lg:text-start lg:min-h-[150px]"
            variant="h1"
          />
          <Ntext
            value={description}
            className="md:!leading-[32px] !-tracking-[0.8px] text-center lg:text-start max-w-[548px] mt-6 lg:mt-8"
            variant="text4lite"
            color="primary-600"
          />
          <section className={buttonsStyle}>
            <Button
              text="Yes, Sign me up"
              className="!font-medium !text-base !text-n-smoky !w-[76vw] lg:!w-[278px] !h-14 lg:z-10"
              onClick={onOpen}
            />
            <ReadMore
              text="Contact sales"
              href={{ url: "tel:+23401888899" }}
              className="!font-medium !text-center !w-[76vw] lg:!w-fit !h-14 contact-btn responsive-btn btn2"
              variant="text3"
            />
          </section>
        </section>
        <article className="relative !max-w-[508px] !max-h-[558px]">
          <FromLastWeek className="absolute -left-5 -bottom-[106px] lg:-left-6 lg:-bottom-7" />
          <img
            alt="A driver with an iPhone showing the Nomba QR code."
            className="rounded-3xl"
            src={Driver}
          />
        </article>
      </Container>
      <RightBlur className={rightBlurStyle} />
      <LeftBlur className={leftBlurStyle} />
    </section>
  );
};

const rightBlurStyle = ctl(`
  absolute
  lg:top-[256px]
  lg:w-[24vw]
  top-[480px]
  h-[92vh]
  w-[48vw]
  right-0
  z-10
`);

const leftBlurStyle = ctl(`
  absolute
  opacity-[.56]
  lg:opacity-100
  lg:w-[16vw]
  h-[776px]
  w-[56vw]
  left-0
  top-0
`);

const wrapperStyle = ctl(`
  bg-n-smoky
  relative
  w-screen
  lg:pt-20
  lg:pb-32
  pt-10
  pb-40
`);

const buttonsStyle = ctl(`
  flex
  flex-col
  items-start
  lg:flex-row
  lg:space-y-0
  lg:space-x-4
  space-y-6
  mt-10
  w-fit
`);

const heroStyle = ctl(`
  flex
  flex-col
  space-y-10
  lg:flex-row
  lg:space-y-0
  lg:justify-between
  lg:items-start
  items-center
`);

export { DriversPageHero };
